import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getSearchAndFilterWidgetStyles = (animation, showFilterUpfront, icon) => {
  var inputFlex = animation === null || animation === void 0 ? void 0 : animation.interpolate({
    inputRange: [0, 1],
    outputRange: showFilterUpfront ? [0.0001, 1] : [1, 0.0001]
  });
  var listFlex = animation === null || animation === void 0 ? void 0 : animation.interpolate({
    inputRange: [0, 1],
    outputRange: showFilterUpfront ? [1, 0.0001] : [0.0001, 1]
  });
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    filterStyle: {
      marginLeft: tokens.spacing.SPACING_8,
      flex: listFlex,
      opacity: listFlex
    },
    inputStyle: {
      opacity: inputFlex,
      flex: inputFlex
    },
    iconButtonStyle: Object.assign({}, icon == 'FilterIcon' ? {
      marginLeft: tokens.spacing.SPACING_8
    } : {})
  });
};